import React, { useState } from "react";
import { Select } from "antd";
import ItemShopWiseSaleReport from "./item-shopwise-sales-report";
import ShopWiseItemsReport from "./storewise-products";

const { Option } = Select;

export default function ShopBased() {
  const [selectOption, setSelectOption] = useState("");
  return (
    <div>
      <div className="card custom-custom py-5 mb-10">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Shop Based Reports</h2>
            </div>
            <div className="col-md-6">
              <div>
                <label htmlFor="">Select a Report</label>
              </div>
              <Select
                className="form-control"
                placeholder="Select a Report"
                onChange={(value) => setSelectOption(value)}
              >
                <Option value="1">Shop wise Items</Option>
                <Option value="2">Shop wise Products</Option>
              </Select>
            </div>
          </div>
        </div>
      </div>

      {selectOption === "1" && <ItemShopWiseSaleReport />}
      {selectOption === "2" && <ShopWiseItemsReport />}
    </div>
  );
}
